import { AppNavigationSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";
import { AppAndFormAction, Category, CreatedBy } from "./gql";
import { UFormData } from "./form";
import { AWSUser, User, UserGroup } from "./auth";

export const enum MenuAction {
  OPEN_SUB_MENU = "OPEN_SUB_MENU",
  OPEN_FORM = "OPEN_FORM",
  SHOW_RESPONSES = "OPEN_TEMPLATE",
  OPEN_LINK = "OPEN_LINK",
  CALL_AN_API = "CALL_AN_API",
  OPEN_DASHBOARD = "OPEN_DASHBOARD",
}

export const MenuActions = [
  MenuAction.OPEN_FORM,
  MenuAction.OPEN_LINK,
  MenuAction.SHOW_RESPONSES,
  MenuAction.OPEN_SUB_MENU,
  MenuAction.CALL_AN_API,
  MenuAction.OPEN_DASHBOARD,
];

export const enum HTTPMethod {
  GET = "GET",
  PUT = "PUT",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export const enum UserPermission {
  ALL_USERS = "allUsers",
  ALL_ADMIN = "allAdmin",
  SPECIFIC_GROUPS = "specificGroups",
  SPECIFIC_USERS = "specificUsers",
}

export const UserPermissions = [
  UserPermission.ALL_ADMIN,
  UserPermission.ALL_USERS,
  UserPermission.SPECIFIC_GROUPS,
  UserPermission.SPECIFIC_USERS,
];

export const HTTPMethodList = [
  HTTPMethod.GET,
  HTTPMethod.PUT,
  HTTPMethod.POST,
  HTTPMethod.PATCH,
  HTTPMethod.DELETE,
];

export interface ApiRequestParameter {
  endpoint: string;
  method: HTTPMethod;
  payload?: string;
  queryString?: string;
  sendToken: boolean;
}

export type AppCategory = Pick<Category, "_id" | "categoryName">;

export interface AppData {
  _id: string;
  createdBy: CreatedBy;
  createdAt: string;
  currentAction: {
    action: AppAndFormAction[];
  };
  category: AppCategory;
  appName: string;
  aiSessionId?: string;
  appDescription: string;
  primaryColor: string;
  fontColor: string;
  currentStatus: string;
  isPushedToMP: boolean;
  favicon: string;
  appLogo: string;
  permissions: {
    allUsers: boolean;
    allAdmins: boolean;
    specificUsers: Pick<User, "_id" | "name" | "sub" | "profilePicture">[];
    specificGroups: Pick<UserGroup, "_id" | "groupName">[];
  };
  navigation: AppNavigationSchemaType;
}

export interface CallAnAPI {
  endpoint: string;
  method: HTTPMethod;
  payload?: string;
  queryString?: string;
  sendToken: boolean;
}

export enum AppMode {
  BUILDER,
  USER,
}

export interface AppItem {
  updatedAt: string;
  _id: string;
  app: {
    _id: string;
    appName: string;
    appDescription: string;
    coverImage: string;
  }[];
  categoryDescription: string;
  categoryName: string;
  createdAt: string;
  coverImage: string;
  reviews: {
    averageRatings: number;
    starRatingMap: string[];
    totalRatings: string;
    totalReviews: string;
  };
}

export const enum UploadMediaType {
  FavIcon = "FaveIcon",
  Logo = "Logo",
}

export type AppOutletContext = {
  user: AWSUser;
};

export type AppFormConfig = Pick<AppData, "_id" | "appName" | "appLogo" | "favicon"> &
  Pick<UFormData, "currentStatus" | "type"> & { user: AWSUser };
